import { render } from "./LandingPageNavbar.vue?vue&type=template&id=6485354b&scoped=true"
import script from "./LandingPageNavbar.vue?vue&type=script&lang=js"
export * from "./LandingPageNavbar.vue?vue&type=script&lang=js"

import "./LandingPageNavbar.vue?vue&type=style&index=0&id=6485354b&lang=scss&scoped=true"

import exportComponent from "/opt/render/project/src/flint.ui/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6485354b"]])

export default __exports__